export default "__VITE_ASSET__5e9d48f0__"